// noinspection DuplicatedCode

import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {useNavigate} from "react-router-dom";

import {alertService} from "../../../services/AlertService";

import TableCard from "../../../components/tablecard/TableCard";
import ModalForm from "../../../components/modal/form/ModalForm";

import {cutiSelector, getCuti, insertCuti, updateCuti} from "./cutiSlice";

import {Colors} from "../../../assets/Colors";

const CutiPage = ({}) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [firstLoading, setFirstLoading] = useState(false);
    const [start, setStart] = useState(0);
    const [count, setCount] = useState(5);
    const [page, setPage] = useState(1);
    const [maxPage, setMaxPage] = useState(0);
    const [search, setSearch] = useState("");
    const [searchFetch, setSearchFetch] = useState(false);
    const [insertFetch, setInsertFetch] = useState(false);
    const [updateFetch, setUpdateFetch] = useState(false);
    const [showModalAdd, setShowModalAdd] = useState(false);
    const [showModalEdit, setShowModalEdit] = useState(false);
    const [currentData, setCurrentData] = useState({});

    const cuti = useSelector(cutiSelector);

    useEffect(() => {
        dispatch(
            getCuti({
                start: start,
                count: count,
                search: "",
            })
        );
    }, []);

    useEffect(() => {
        if (search !== "" && cuti?.isGetSuccess && !cuti.isGetFetching) {
            let calc = cuti?.count - 1;
            if (calc === 0) {
                calc = 1;
            }

            if ((calc % count) === 0) {
                calc = calc + 1;
            }

            let tempMaxPage = cuti.data ? Math.ceil(calc / count) : 1;
            setSearchFetch(false);
            setMaxPage(tempMaxPage);
        }

        if (search === "" && cuti?.isGetSuccess && !cuti.isGetFetching) {
            let calc = cuti?.count - 1;

            if (calc === 0) {
                calc = 1;
            }

            if ((calc % count) === 0) {
                calc = calc + 1;
            }

            setSearchFetch(false);
            setMaxPage(Math.ceil(calc / count));
        }

        if (
            !cuti?.isGetFetching &&
            cuti?.isGetSuccess &&
            maxPage === 0 &&
            firstLoading === false
        ) {
            let calc = cuti?.count - 1;
            if (calc === 0) {
                calc = 1;
            }

            if ((calc % count) === 0) {
                calc = calc + 1;
            }
            setMaxPage(Math.ceil(calc / count));
            setFirstLoading(true);
            dispatch(
                getCuti({
                    start: start,
                    count: count,
                    search: search,
                })
            );
        }

        if (insertFetch) {
            setInsertFetch(false);
            alertService.success(cuti.message, {
                autoClose: true,
                keepAfterRouteChange: false,
            });
            dispatch(
                getCuti({
                    start: start,
                    count: count,
                    search: search,
                })
            );
        }

        if (updateFetch) {
            setUpdateFetch(false);
            alertService.success(cuti.message, {
                autoClose: true,
                keepAfterRouteChange: false,
            });
            dispatch(
                getCuti({
                    start: start,
                    count: count,
                    search: search,
                })
            );
        }
    });

    // function handleGetCuti(params) {
    //   return dispatch(getCuti(params));
    // }

    function handleInsertCuti(param) {
        setInsertFetch(true);
        const params = {
            namaCuti: param.inputOneValue,
            golonganID: param.dropdownGolonganValue,
            tipeKaryawanID: param.dropdownTipeKaryawanValue,
            jumlahCuti: param.inputNumberOneValue,
            tiketPesawat: param.inputNumberTwoValue,
        };
        dispatch(insertCuti(params));
    }

    function handleUpdateCuti(param) {
        setUpdateFetch(true);

        const params = {
            setupCutiID: currentData.SetupCutiID,
            namaCuti: param.inputOneValue,
            golonganID: param.dropdownGolonganValue,
            tipeKaryawanID: param.dropdownTipeKaryawanValue,
            jumlahCuti: param.inputNumberOneValue,
            tiketPesawat: param.inputNumberTwoValue,
            status: param.status,
        };
        dispatch(updateCuti(params));
    }

    function handleSearch(searchValue) {
        let params = {
            start: 0,
            count: 5,
            search: searchValue,
        };
        dispatch(getCuti(params));

        setStart(0);
        setCount(5);
        setSearch(searchValue);
        setSearchFetch(true);
    }

    function handleUpdatePage(newPage) {
        let newStart = newPage * count - count;

        let params = {
            start: newStart,
            count: count,
            search: search,
        };
        dispatch(getCuti(params));

        setPage(newPage);
        setStart(newStart);
    }

    function handleUpdateCount(newCount) {
        let calc = cuti.count - 1;
        if (calc === 0) {
            calc = 1;
        }

        let params = {
            start: newCount === "-1" ? 0 : start,
            count: newCount === "-1" ? cuti.count : newCount,
            search: search,
        };
        dispatch(getCuti(params));

        setPage(1);
        setCount(newCount === "-1" ? cuti.count : newCount);
        setStart(newCount === "-1" ? 0 : start);
        setMaxPage(newCount === "-1" ? 1 : Math.ceil(calc / newCount));
    }

    function handleCurrentData(values) {
        setCurrentData(values);
    }

    function handleModal(status) {
        setShowModalAdd(status.showModalAdd);
        setShowModalEdit(status.showModalEdit);
    }

    if (!firstLoading) {
        return <div>loading</div>;
    } else {
        return (
            <div className="md:ml-64">
                <div style={{background: Colors.primary}} className="pt-14 pb-16 px-3 md:px-8 h-auto">
                    <div className="container mx-auto max-w-full">
                        <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-4"></div>
                    </div>
                </div>

                <div className="px-3 md:px-8 h-auto -mt-32">
                    <div className="container mx-auto max-w-full">
                        <div className="grid grid-cols-1 px-4">
                            <TableCard

                                handleSearch={handleSearch}
                                searchPlaceholder="Cuti"
                                updatePage={handleUpdatePage}
                                updateCount={handleUpdateCount}
                                currentData={handleCurrentData}
                                currentPage={page}
                                maxPage={maxPage}
                                tableTitle="Master Cuti"
                                tableData={cuti.data}
                                colOneTitle="ID"
                                colOneData="SetupCutiID"
                                colTwoTitle="Jenis Cuti"
                                colTwoData="NamaSetupCuti"
                                colThreeTitle="Golongan"
                                colThreeData="NamaGolongan"
                                colFourTitle="Tipe Karyawan"
                                colFourData="NamaTipeKaryawan"
                                colFiveTitle="Jumlah Cuti"
                                colFiveData="JumlahCuti"
                                colSixTitle="Tiket Pesawat"
                                colSixData="TiketPesawat"
                                status="Status"
                                fetching={cuti.isGetFetching}
                                modal={handleModal}
                                editEnabled={true}
                            />
                        </div>
                    </div>
                </div>
                {showModalAdd && (
                    <ModalForm
                        showModal={showModalAdd}
                        addEnabled={true}
                        modal={handleModal}
                        modalTitle="Tambah Cuti"
                        dropdownGolongan={true}
                        dropdownTipeKaryawan={true}
                        inputOneTitle="Nama Cuti"
                        inputOnePlaceholder=""
                        inputNumberOneTitle="Jumlah Cuti"
                        inputNumberTwoTitle="Tiket Pesawat"
                        submitButtonTitle="Submit"
                        handleSubmit={handleInsertCuti}
                    />
                )}
                {showModalEdit && (
                    <ModalForm
                        showModal={showModalEdit}
                        editEnabled={true}
                        id={currentData.SetupCutiID}
                        modal={handleModal}
                        modalTitle="Ubah Cuti"
                        dropdownGolongan={true}
                        dropdownTipeKaryawan={true}
                        dropdownGolonganValue={currentData.GolonganID}
                        dropdownTipeKaryawanValue={currentData.TipeKaryawanID}
                        inputOneTitle="Nama Cuti"
                        inputOneValue={currentData.NamaSetupCuti}
                        status={currentData.Status}
                        inputNumberOneTitle="Jumlah Cuti"
                        inputNumberOneValue={currentData.JumlahCuti}
                        inputNumberTwoTitle="Tiket Pesawat"
                        inputNumberTwoValue={currentData.TiketPesawat}
                        submitButtonTitle="Submit"
                        handleSubmit={handleUpdateCuti}
                    />
                )}
            </div>
        );
    }
};

export default CutiPage;
